module.exports = __webpack_public_path__ + "media/site_templates/www.localplasterers.com.au/images/splash-370dce132dde868bb9bfd028e4b0ed72.jpeg";